<template>
  <AppCard design="new" variant="table" header-density="compact">
    <AppDataTable design="new" density="dense" :columns="columns" :rows="rows" clickable min-width="1200px" @row-click="open($event.row, $event.event)">
      <template #cell="{ row, column }">
        <span v-if="column.key === 'id'" class="ui-cell-inline">
          <AppTableText :text="String(row.id || '')" />
          <OperationsCopyButton v-if="row.id" :value="String(row.id)" />
        </span>
        <span v-else-if="column.key === 'status'" class="ui-cell-inline">
          <AppStatusBadge design="new" compact :tone="color(row.execution_status)" :label="humanize(row.execution_status)" :aria-label="`Execution: ${humanize(row.execution_status)}`" />
          <AppStatusBadge v-if="row.delivery_status && row.delivery_status !== 'not_applicable'" design="new" compact :tone="color(row.delivery_status)" :label="delivery(row)" :aria-label="`Delivery: ${delivery(row)}`" />
          <AppStatusBadge v-if="['pending', 'failed'].includes(row.sync_status)" design="new" compact :tone="color(row.sync_status)" :label="`Updates ${row.sync_status}`" />
          <i v-if="statusInfo(row)" v-tooltip="tip(statusInfo(row))" class="pi pi-info-circle ui-tooltip-target" tabindex="0" :aria-label="statusInfo(row)" />
        </span>
        <AppTableText v-else :text="value(row, column.key)" :tooltip="extraInfo(row, column.key)" />
      </template>
    </AppDataTable>
  </AppCard>
</template>

<script>
import AppTableText from '@/components/AppTableText.vue'
import OperationsCopyButton from './OperationsCopyButton.vue'
import RecordTable from './RecordTable.vue'
import { dateLabel, humanize, tone } from './model'

export default {
  name: 'OperationsTable',
  extends: RecordTable,
  components: { AppTableText, OperationsCopyButton },
  computed: {
    columns() { return RecordTable.computed.columns.call(this).map(column => column.key === 'status' ? { ...column, width: '300px' } : column) }
  },
  methods: {
    color: tone,
    humanize,
    delivery(row) { return row.integration === 'email' && row.delivery_status === 'read' ? 'Opened signal' : humanize(row.delivery_status) },
    statusInfo(row) {
      const details = []
      if (row.next_attempt_at) details.push(`Next attempt: ${dateLabel(row.next_attempt_at, true)}`)
      if (row.attention_reasons && row.attention_reasons.length) details.push(row.attention_reasons.join('; '))
      return details.join('. ')
    },
    extraInfo(row, key) {
      if (key === 'created_at' && row.created_at) return dateLabel(row.created_at, true)
      if (key === 'attempt_count' && row.last_attempt_at) return `Last attempt: ${dateLabel(row.last_attempt_at, true)}`
      if (key === 'recipient' && row.recipient?.items?.length > 1) return row.recipient.items.map(item => [item.label, item.address].filter(Boolean).join(' · ')).join('\n')
      return ''
    }
  }
}
</script>
